import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../context/LanguageContext";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import Select from "../../../components/select/main/Select";
import { StyledInput } from "../../../styles/InputStyles";
import PaxtonVisitorTypes from "./visitor_types/PaxtonVisitorTypes";
import PaxtonDoors from "./doors/PaxtonDoors";
import TimezoneSelect from "../../../components/select/custom/timezone/TimezoneSelect";

function PaxtonConfigsPageView({
  configData,
  setConfigData,
  paxtonResources,
  visitorTypes,
  onChange,
  submitError,
  onSubmit,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="paxton_configs_page_fetch">
        <FormContainer
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"paxton_configs_page_save"}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.active")}
              required
              error={EVAApiHelper.getResponseError("active", submitError)}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.active}
                onChange={(value) => onChange("active", value)}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.version")}
              required
              error={EVAApiHelper.getResponseError("version", submitError)}
            >
              <Select
                options={[
                  { value: "net2", label: "Net2" },
                  { value: "paxton10", label: "Paxton10" },
                ]}
                value={configData.version}
                onChange={(value) => onChange("version", value)}
                disabled
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.url")}
              required
              error={EVAApiHelper.getResponseError("url", submitError)}
            >
              <StyledInput
                type="text"
                placeholder={translate("eva.main.validation.attributes.url")}
                value={configData.url}
                onChange={(e) => onChange("url", e.target.value)}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.client_id")}
              required
              error={EVAApiHelper.getResponseError("client_id", submitError)}
            >
              <StyledInput
                type="text"
                placeholder={translate(
                  "eva.main.validation.attributes.client_id",
                )}
                value={configData.client_id}
                onChange={(e) => onChange("client_id", e.target.value)}
              />
            </InputWrapper>

            <StyledFlexRow>
              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.username")}
                  required
                  error={EVAApiHelper.getResponseError("username", submitError)}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.username",
                    )}
                    value={configData.username}
                    onChange={(e) => onChange("username", e.target.value)}
                  />
                </InputWrapper>
              </StyledFlexItem>

              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.password")}
                  required
                  error={EVAApiHelper.getResponseError("password", submitError)}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.password",
                    )}
                    value={configData.password}
                    onChange={(e) => onChange("password", e.target.value)}
                  />
                </InputWrapper>
              </StyledFlexItem>
            </StyledFlexRow>

            <InputWrapper
              label={translate("eva.main.validation.attributes.timezone")}
              error={EVAApiHelper.getResponseError("timezone", submitError)}
            >
              <TimezoneSelect
                value={configData.timezone}
                onChange={(value) => onChange("timezone", value)}
                nullable={true}
                placeholder={translate("eva.main.company.timezone.inherit")}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.sync_employees")}
              required
              error={EVAApiHelper.getResponseError(
                "sync_employees",
                submitError,
              )}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.sync_employees}
                onChange={(val) => onChange("sync_employees", val)}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.sync_visitors")}
              required
              error={EVAApiHelper.getResponseError(
                "sync_visitors",
                submitError,
              )}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.sync_visitors}
                onChange={(val) => onChange("sync_visitors", val)}
              />
            </InputWrapper>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <PaxtonDoors
        configData={configData}
        setConfigData={setConfigData}
        paxtonResources={paxtonResources}
      />

      <PaxtonVisitorTypes
        configData={configData}
        setConfigData={setConfigData}
        paxtonResources={paxtonResources}
        visitorTypes={visitorTypes}
      />
    </StyledFlexColumn>
  );
}

export default PaxtonConfigsPageView;
